// Hot spot properties for help popovers
export const hotProps = [
    'companiesDropdown',
    'storesMultiselect',
    'reportsTransactions',
    'quickSearch',
    'reportsBanks',
    'downloadReports',
    'cardScheme',
    'cardsDates',
    'transactionTypes',
    'exportChartHints',
    'downloadBusinessExcel',
    'eCommerceBusiness',
    'transactionExcelButton',
    'transactionDetailsInfo',
    'transactionSettlingInfo',
    'settledTransactions',
    'pendingTransactions',
    'threeDSecureHeader',
    'isSettledTransactionHeader',
    'responseCodeHeader'
];

// All tooltip identifiers for info tooltips
export const allTooltips = [
    'company-tk-tltp',
    'mid-tltp',
    'quickfind-tltp',
    'refund-tltp',
    'multiple-mid-popover-tltp',
    'business-export-tltp',
    'business-export-tid-tltp',
    'report-download-multiple-mid-tltp',
    'report-download-cardless-note-tltp',
    'reports-right-column-title-tltp',
    'download-excel-trans-tltp',
    'download-excel-ecom-tltp',
    'download-excel-install-tltp',
    'download-excel-cardless-tltp',
    'business-mid-alias-tltp',
    'download-trans-tltp',
    'business-tid-alias-tltp',
    'reports-transactions-chart-tltp',
    'overview-kpi-title-tltp',
    'duplicate-transactions-tltp',
    'card-number-tltp',
    'reset-pw-frm-tltp',
    'new-pw-frm-tltp'
];
